<template>
  <div class="new-order">
    <div class="sub-title">Nieuwe offerte</div>

    <div class="col-md-13 text-center p-0 mt-md-4 mt-2">
      <button @click="confirmCreateQuotation" type="button" class="btn btn-oldevuuren btn-round w-100">
        Offerte aanmaken
      </button>
    </div>

    <b-modal ref="create-quotation-modal" id="create-quotation-modal" footer-class="modal-footer modal-save-details" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">Let op!</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          Als je een nieuwe invoer start wordt de huidige invoer "{{ reference }}" overschreven.
        </div>
      </template>

      <template slot="modal-footer">
        <button
          @click="createQuotation"
          type="button"
          class="btn btn-oldevuuren btn-round">Nieuwe invoer
        </button>
        <button
          @click="cancelCreation"
          type="button"
          class="btn btn-round">Annuleren
        </button>
      </template>
    </b-modal>

  </div>
</template>

<script>
  // General
  import { RESET_CART } from '../../store/types'

  export default {
    methods: {
      hideModal() {
        this.$refs['create-quotation-modal'].hide()
      },
      confirmCreateQuotation() {
        // We need to make sure the user wants to remove his old cart
        if (this.reference) {
          // Show dialog
          this.$refs['create-quotation-modal'].show()
        } else {
          this.createQuotation()
        }
      },
      createQuotation() {
        this.$store.dispatch(RESET_CART)
        this.$router.push({ name: 'tool' })
      },
      cancelCreation() {
        this.$refs['create-quotation-modal'].hide()
      }
    },
    computed: {
      reference() {
        let cart = JSON.parse(localStorage.getItem('cart'))
        return cart ? cart.reference : null
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
